// test1017
(1017 && 0);
